import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { type Trend } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { type GetTrendingOnSpotlightQuery, trendingOnSpotlight } from "../api/queries";

type UseTrendingOnSpotlightReturn = ApolloResult<{
    trends: readonly Trend[];
}>;

export const useTrendingOnSpotlight = (): UseTrendingOnSpotlightReturn => {
    const { data, loading, error } = useQuery<GetTrendingOnSpotlightQuery>(trendingOnSpotlight);

    return useMemo(() => {
        return {
            loading,
            error,
            trends: data?.trendingOnSpotlight ?? [],
        };
    }, [data?.trendingOnSpotlight, error, loading]);
};
